import { addLocaleData } from 'react-intl';
import en from 'react-intl/locale-data/en';
import es from 'react-intl/locale-data/es';
import fr from 'react-intl/locale-data/fr';
import de from 'react-intl/locale-data/de';
import it from 'react-intl/locale-data/it';
import ja from 'react-intl/locale-data/ja';

export const KNOWN_LOCALES = ['en', 'en_GB', 'fr', 'de', 'it', 'es', 'ja'];

export function normalizeLocale(locale) {
  if (KNOWN_LOCALES.includes(locale)) {
    return locale;
  }
  if (locale && locale.length > 2) {
    const firstTwo = locale.substring(0, 2);
    if (KNOWN_LOCALES.includes(firstTwo)) {
      return firstTwo;
    }
  }
  return 'en';
}

export function addLocales(cb = () => {}) {
  addLocaleData(en);
  addLocaleData(es);
  addLocaleData(fr);
  addLocaleData(de);
  addLocaleData(it);
  addLocaleData(ja);

  if (!window.Intl) {
    require.ensure([
      'intl',
      'intl/locale-data/jsonp/en.js',
      'intl/locale-data/jsonp/es.js',
      'intl/locale-data/jsonp/fr.js',
      'intl/locale-data/jsonp/de.js',
      'intl/locale-data/jsonp/it.js',
      'intl/locale-data/jsonp/ja.js',
    ], (require) => {
      require('intl');
      require('intl/locale-data/jsonp/en.js');
      require('intl/locale-data/jsonp/es.js');
      require('intl/locale-data/jsonp/fr.js');
      require('intl/locale-data/jsonp/de.js');
      require('intl/locale-data/jsonp/it.js');
      require('intl/locale-data/jsonp/ja.js');

      cb();
    });
  } else {
    cb();
  }
}



// WEBPACK FOOTER //
// ./src/portfolio-shared/util/addLocales.js